import { useCallback, useState } from "react";
import { DEFAULT_PAGE_SIZE } from "@/features/inheritanceReuse/utils/constants";

// 相続後リユース候補テーブル用のサーバサイドページネーション hook。
// フィルタ変更時にページを先頭へ戻す resetPage() を備える。

const DEFAULT_PAGE = 0;

interface IUseGridPaginationReturnType {
  page: number;
  pageSize: number;
  changePage: (pageIndex: number) => void;
  changePageSize: (pageSize: number) => void;
  resetPage: () => void;
}

export const useGridPagination = (): IUseGridPaginationReturnType => {
  const [page, setPage] = useState(DEFAULT_PAGE);
  const [pageSize, setPageSize] = useState(DEFAULT_PAGE_SIZE);

  const changePage = useCallback((page: number): void => {
    setPage(page);
  }, []);

  const changePageSize = useCallback((pageSize: number): void => {
    setPage(DEFAULT_PAGE);
    setPageSize(pageSize);
  }, []);

  const resetPage = useCallback((): void => {
    setPage(DEFAULT_PAGE);
  }, []);

  return { page, pageSize, changePage, changePageSize, resetPage };
};
